// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Person40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Person40: FC<Person40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M20 19.972c-1.833 0-3.357-.606-4.57-1.819-1.212-1.213-1.819-2.736-1.819-4.57 0-1.833.607-3.356 1.82-4.569s2.736-1.82 4.569-1.82c1.833 0 3.357.607 4.57 1.82 1.212 1.213 1.819 2.736 1.819 4.57 0 1.833-.607 3.356-1.82 4.57-1.212 1.212-2.736 1.818-4.569 1.818ZM6.667 33.334v-4.167c0-1.019.257-1.91.77-2.674a5 5 0 0 1 2.008-1.743c1.814-.842 3.587-1.474 5.319-1.896A22.07 22.07 0 0 1 20 22.222c1.76 0 3.5.216 5.222.646 1.722.43 3.49 1.06 5.303 1.888.849.4 1.529.98 2.04 1.742.512.76.768 1.65.768 2.669v4.167H6.667Zm2.778-2.778h21.11v-1.39c0-.397-.113-.772-.34-1.124a2.215 2.215 0 0 0-.854-.792c-1.685-.824-3.273-1.405-4.764-1.743A20.723 20.723 0 0 0 20 25c-1.574 0-3.116.17-4.625.507-1.51.338-3.097.92-4.764 1.743-.343.176-.623.44-.84.792a2.104 2.104 0 0 0-.326 1.125v1.389ZM20 17.195c1.028 0 1.887-.345 2.576-1.035.69-.69 1.035-1.549 1.035-2.576 0-1.028-.345-1.887-1.035-2.577S21.028 9.972 20 9.972s-1.887.345-2.576 1.035c-.69.69-1.035 1.549-1.035 2.577 0 1.027.345 1.886 1.035 2.576.69.69 1.548 1.035 2.576 1.035Z" />
        </svg>
    );
};

export default Person40;
